import { Inbox, CalendarClock, PieChart, Building2, Search, X } from 'lucide-react';
import { STATUSES, statusClass } from './adminApi';

export const SummaryCards = ({ stats }) => {
  const breakdown = stats?.statusBreakdown || {};
  return <div className="admin-cards" data-testid="admin-summary-cards">
    <div className="admin-card" data-testid="summary-total">
      <span><Inbox size={13} />Total submissions</span>
      <strong>{stats?.total ?? 0}</strong>
      <small>All time</small>
    </div>
    <div className="admin-card" data-testid="summary-week">
      <span><CalendarClock size={13} />New this week</span>
      <strong>{stats?.newThisWeek ?? 0}</strong>
      <small>Last 7 days</small>
    </div>
    <div className="admin-card" data-testid="summary-status">
      <span><PieChart size={13} />Status breakdown</span>
      <div className="admin-card-breakdown">
        {STATUSES.filter(s => breakdown[s]).map(s => <span key={s} className={`admin-mini-pill ${statusClass(s)}`}>{s} {breakdown[s]}</span>)}
        {!STATUSES.some(s => breakdown[s]) && <span className="admin-mini-pill">No entries yet</span>}
      </div>
    </div>
    <div className="admin-card" data-testid="summary-industry">
      <span><Building2 size={13} />Top industry</span>
      <strong style={{ fontSize: 18, lineHeight: 1.3 }}>{stats?.topIndustry?.name || '—'}</strong>
      <small>{stats?.topIndustry ? `${stats.topIndustry.count} submission${stats.topIndustry.count === 1 ? '' : 's'}` : 'Awaiting data'}</small>
    </div>
  </div>;
};

export const Toolbar = ({ filters, industries, onChange, onClear }) => {
  const dirty = filters.search || filters.status || filters.industry || filters.from || filters.to || filters.sort !== 'newest';
  return <div className="admin-toolbar" data-testid="admin-toolbar">
    <div className="admin-search">
      <Search size={15} />
      <input type="search" value={filters.search} onChange={e => onChange({ search: e.target.value })}
        placeholder="Search name, company or email" aria-label="Search submissions" data-testid="admin-search-input" />
    </div>
    <select className="admin-control" value={filters.status} onChange={e => onChange({ status: e.target.value })} aria-label="Filter by status" data-testid="admin-filter-status">
      <option value="">All statuses</option>
      {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
    </select>
    <select className="admin-control" value={filters.industry} onChange={e => onChange({ industry: e.target.value })} aria-label="Filter by industry" data-testid="admin-filter-industry">
      <option value="">All industries</option>
      {industries.map(i => <option key={i} value={i}>{i}</option>)}
    </select>
    <div className="admin-date-group">
      <input type="date" className="admin-control" value={filters.from} onChange={e => onChange({ from: e.target.value })} aria-label="From date" data-testid="admin-filter-from" />
      <span>to</span>
      <input type="date" className="admin-control" value={filters.to} onChange={e => onChange({ to: e.target.value })} aria-label="To date" data-testid="admin-filter-to" />
    </div>
    <select className="admin-control" value={filters.sort} onChange={e => onChange({ sort: e.target.value })} aria-label="Sort submissions" data-testid="admin-sort">
      <option value="newest">Newest first</option>
      <option value="oldest">Oldest first</option>
      <option value="company">Company A–Z</option>
    </select>
    {dirty && <button type="button" className="admin-clear" onClick={onClear} data-testid="admin-clear-filters"><X size={12} style={{ display: 'inline', marginRight: 4 }} />Clear filters</button>}
  </div>;
};
